import React from "react";
import "./LogIn.css";

const LogInButton = ({ onOpenLogin }) => {
  return (
    <button onClick={onOpenLogin} className="LogIn_navBar_but">
      Log In
    </button>
  );
};

export default LogInButton;
